export const getQueryString = (state) => state?.router?.location?.search || '';
export const getPathName = (state) => state?.router?.location?.pathname || '';
